import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from 'helpers/api';

const initialState = { items: [], loaded: false };

export const getUserPermissions = createAsyncThunk('getUserPermissions', async () => {
  const res = await apiRequest(`users/permissions`, {}, 'get');
  return res.result;
});

const userPermissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getUserPermissions.fulfilled, (state, action) => {
      state.items = action.payload;
      state.loaded = true;
    });
    builder.addCase(getUserPermissions.rejected, state => {
      state.loaded = true;
    });
  },
});

export const selectPermissions = state => state.permissions.items;
export const selectPermissionsLoaded = state => state.permissions.loaded;

export default userPermissionsSlice.reducer;
